const endPoint = 'https://plusdoctor-api-test.ifourtechlab.com';
const apiVersion = 'v2';

export const environment = {
    environmentType: 'plusdoctor',
    appVersion: require("../../package.json").version, //Fetching vesion of application.

    production: true,
    endPoint: endPoint,
    apiVersion: apiVersion,
    apiUrl: `${endPoint}/api/${apiVersion}`
};
